export const toolCallsContainerStyles = {
  gap: '8px',
};

export const toolCallRowStyles = {
  gap: '2px',
};

export const toolCallLabelStyles = {
  wordBreak: 'break-word',
};

export const toolCallDetailStyles = {
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
};
